import { style } from '@angular/animations';
export class AnimationStyleMove {
   public static displayPosition = style({
      transform: 'none',
   });

   public static topPosition = style({
      transform: 'translate3d(0, -100%, 0)',
   });

   public static bottomPosition = style({
      transform: 'translate3d(0, 100%, 0)',
   });

   public static leftPosition = style({
      transform: 'translate3d(-100%, 0, 0)',
   });

   public static rightPosition = style({
      transform: 'translate3d(100%, 0, 0)',
   });

   public static twistRight = style({
      transform: 'skewX(-30deg)',
   });

   public static twistRightLight = style({
      transform: 'skewX(-20deg)',
   });

   public static twistRightVeryLight = style({
      transform: 'skewX(-5deg)',
   });

   public static twistLeft = style({
      transform: 'skewX(30deg)',
   });

   public static twistLeftLight = style({
      transform: 'skewX(20deg)',
   });

   public static twistLeftVeryLight = style({
      transform: 'skewX(5deg)',
   });

   public static twistTop = style({
      transform: 'skewY(30deg)',
   });

   public static twistTopLight = style({
      transform: 'skewY(20deg)',
   });

   public static twistTopVeryLight = style({
      transform: 'skewY(5deg)',
   });

   public static twistBottom = style({
      transform: 'skewY(-30deg)',
   });

   public static twistBottomLight = style({
      transform: 'skewY(-20deg)',
   });

   public static twistBottomVeryLight = style({
      transform: 'skewY(-5deg)',
   });
}
